import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagAO = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M0 25C0 11.193 11.193 0 25 0s25 11.193 25 25c-1.087 0-25 3.26-25 3.26L0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m21.571 19.884 2.12 1.538-.808 2.491L25 22.373l2.12 1.538-.812-2.49 2.118-1.54h-2.619l-.81-2.49-.808 2.492-2.619.001Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M31.25 14.174a12.42 12.42 0 0 0-6.25-1.67v3.26a9.177 9.177 0 0 1 4.619 1.234c4.412 2.548 5.929 8.21 3.382 12.621-2.547 4.412-8.21 5.93-12.621 3.382a9.177 9.177 0 0 1-3.088-2.912l-2.722 1.797a12.42 12.42 0 0 0 4.18 3.939c5.969 3.446 13.629 1.394 17.075-4.575 3.446-5.97 1.394-13.63-4.576-17.076Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M17.791 22.825a3.261 3.261 0 0 0 1.296 4.426l10.59 5.787c-.72 1.317-.337 2.92.98 3.64l2.86 1.564a2.718 2.718 0 0 0 3.689-1.08l1.565-2.86-20.98-11.477Z"
}));
FlagAO.displayName = 'FlagAO';
export default withFlagWrapper(FlagAO);
//# sourceMappingURL=index.js.map